module.exports = __webpack_public_path__ + "img/单据.9124d0d2.svg";